// extracted by mini-css-extract-plugin
export var anticlockwise = "cd_kk";
export var svg = "cd_kh";
export var wrapper = "cd_C";
export var wrapperFlexCenter = "cd_kj";